import Title from "antd/es/typography/Title"
import Structure from "../Structure"
import { Card, Col, Divider, Row } from 'antd';
import { useState } from "react";
import CrearNuevoCampoPersonalizado from "./crear";
import ButtonGroup from "antd/es/button/button-group";
import ListadoCategorias from "./listado";
import MenuCategorias from "../../subComponents/general/menu_categorias";
import { rutas } from "../../lib/routes/routes";

const Categorias = (props) => {
    const {
        tipo,
        titulo
    } = props
    const [ condicion_busqueda, setCondicionBusqueda ] = useState({ tipo })
    const titular = titulo ? titulo : "Categorías"

    const render = () => {
        return <div>
            <Card>
            <Title className="mb-2 mt-0">{titular}</Title>
            <ButtonGroup>
            <CrearNuevoCampoPersonalizado tipo={tipo} onCreate={() => setCondicionBusqueda(prev => ({...{}, ...condicion_busqueda}))} />
            </ButtonGroup>
            <MenuCategorias default_selected="categorias" menu_categorias={rutas.clients_categories.slug} menu_sub_categorias={rutas.clients_sub_categories.slug} />
            <Divider />
                <ListadoCategorias tipo={tipo} condicion_default={condicion_busqueda} />
            </Card>
        </div>
    }
    
    return <Structure component={render()} />
}

export default Categorias